export const QUERY_STATUS = Object.freeze({
  ERROR: 'error',
  LOADING: 'loading',
  EMPTY: 'empty',
  READY: 'ready',
});

export function deriveQueryStatus({ loading, error, isEmpty }) {
  if (error) return QUERY_STATUS.ERROR;
  if (loading) return QUERY_STATUS.LOADING;
  if (isEmpty) return QUERY_STATUS.EMPTY;
  return QUERY_STATUS.READY;
}
